import { render, staticRenderFns } from "./Pricing3.vue?vue&type=template&id=5e3c90c3"
import script from "./Pricing3.vue?vue&type=script&lang=js"
export * from "./Pricing3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports